import { Container } from "@brightagency/headstart-common";
import React from "react";
import { useAssessmentState } from "../../../services/assessment-state";
import { screenOrder, Screens } from "../../../services/assessment-state/types";
import { AnimateAutoHeight } from "../../atoms/AnimateAutoHeight";
import { ProgressBar } from "./ProgressBar";
import { createScreenMapping } from "./ScreenMapping";
import {
    FadeSwitchAnimationWrapper,
    NavigationButtons,
    OuterSection,
    Section,
    SectionTitle,
} from "./shared";
import { QuizWrapper, NavOffsetFix } from "./styled";

export const AssessmentContent: React.FC = () => {
    const { state, currentScreenIndex , goNext} = useAssessmentState();
    const screenMapping = createScreenMapping();
    const current = screenMapping[state.currentScreen];
    const meta = current.createMeta(state);
    
    { 
        state.suburb ? 
            (state.showselection == 0) ? 
                (state.currentScreen == 1) ? goNext() : '' 
            :
                ''
        :     
            ''
    }

    return (
        <FadeSwitchAnimationWrapper changeKey={String(state.currentScreen === Screens.Results)}>
            <NavOffsetFix>
                {state.currentScreen === Screens.Results ? (
                    current.rendered
                ) : (
                    <QuizWrapper>
                        <Container className="assesment-container">
                            <OuterSection className="assesment-outer">
                                <AnimateAutoHeight>
                                    <FadeSwitchAnimationWrapper
                                        changeKey={String(state.currentScreen !== Screens.Intro)}
                                    >
                                        {state.currentScreen !== Screens.Intro && (
                                            <ProgressBar
                                                total={screenOrder.length - 2}
                                                current={currentScreenIndex}
                                            />
                                        )}
                                    </FadeSwitchAnimationWrapper>
                                    <FadeSwitchAnimationWrapper changeKey={meta.title}>
                                        <SectionTitle>{meta.title}</SectionTitle>
                                    </FadeSwitchAnimationWrapper>
                                    <FadeSwitchAnimationWrapper
                                        delay={100}
                                        changeKey={state.currentScreen}
                                    >
                                        <Section className="contentContainer">{current.rendered}</Section>
                                    </FadeSwitchAnimationWrapper>
                                </AnimateAutoHeight>
                                <FadeSwitchAnimationWrapper
                                    delay={200}
                                    changeKey={String(state.currentScreen !== Screens.Intro)}
                                >
                                    {state.currentScreen !== Screens.Intro && (
                                        <NavigationButtons
                                            isSkippable={meta.canSkip && state.currentScreen !== Screens.WhoFor}
                                            isEnabled={meta.canProgress}
                                        />
                                    )}
                                </FadeSwitchAnimationWrapper>
                            </OuterSection>
                        </Container>
                    </QuizWrapper>
                )}
            </NavOffsetFix>
        </FadeSwitchAnimationWrapper>
    );
};
